/* eslint-disable sort-keys-fix/sort-keys-fix */
import { FunnelStep, ProposalState } from 'types';

export const STEP_TO_FUNNEL_KEY: {
  [key in Exclude<FunnelStep, 'data'>]: keyof ProposalState | 'skip';
} = {
  'concern-type': 'concernType',
  relationship: 'relationship',
  place: 'city',
  type: 'funeralType',
  character: 'funeralPlan',
};

export const STEP_TO_TRACKING_NAME: Record<FunnelStep, string> = {
  character: 'create.character',
  'concern-type': 'create.concerns',
  data: 'create.data',
  place: 'create.place',
  relationship: 'create.relationship',
  type: 'create.type',
};
